"use strict";

exports.__esModule = true;
exports.default = getRef;

var _forwardRef = require("./forwardRef");

var _RefForwarder = _interopRequireDefault(require("./RefForwarder"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getRef(refObject) {
  if (!refObject) {
    return null;
  }

  var ref = refObject;

  if (Object.keys(ref).length === 1) {
    if (ref.hasOwnProperty('current')) {
      ref = ref.current; // We probably don't have to support this route since it was only
      // in one version of React and it was an alpha release (16.3.0-alpha.1).
    } else if (ref.hasOwnProperty('value')) {
      ref = ref.value;
    }
  } // Get polyfilled forwardedRef, if it exists


  if (ref instanceof _RefForwarder.default) {
    ref = ref.getRef();
  }

  return ref;
}